<template>
  <li class="el-select-search-input el-select-dropdown__item"
    :class="{
      'is-empty': empty
    }"
    v-show="isShow">
    <el-input
      class="search-input"
      v-model="searchCenter"
      @click.native.stop
      clearable
      debounce
      :validate-event="false"
      placeholder="请输入搜索内容"
      ref="searchInput">
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <div class="empty" v-if="empty">
      无匹配数据
    </div>
  </li>
</template>

<script>
export default {
  name: 'ElSelectSearchInput',
  inject: ['select'],
  data () {
    return {
      searchCenter: '',
      empty: false,
      isShow: false
    }
  },
  watch: {
    searchCenter: {
      handler(newVal) {
        if (this.select.remote && typeof this.select.remoteMethod === 'function') {
          this.select.hoverIndex = -1;
          this.select.remoteMethod(newVal);
        } else if (typeof this.select.filterMethod === 'function') {
          this.select.filterMethod(newVal);
          this.select.broadcast('ElOptionGroup', 'queryChange');
        } else {
          this.select.filteredOptionsCount = this.select.optionsCount;
          this.select.broadcast('ElOption', 'queryChange', newVal);
          this.select.broadcast('ElOptionGroup', 'queryChange');
        }
      }
    },
    'select.filteredOptionsCount': {
      immediate: true,
      handler(newVal) {
        this.empty = newVal === 0
      }
    },
    'select.visible': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {this.isShow = true})
        } else {
          this.$nextTick(() => {this.isShow = false})
        }
      }
    },
    empty () {
      this.$el.parentNode.style.paddingTop = this.empty ? '64px' : '40px'
    }
  }
}
</script>

